import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import { useChartHelper } from './helper';

export default function ProgressPerTime({
  data = { publishments: [] },
  isConsolidated = false,
  loading,
}) {
  const ref = useRef();
  const { t } = useTranslation();

  useChartHelper({ ref, publishments: data.publishments, isConsolidated }, t);

  return (
    <Widget
      className="custom-width"
      title={t('Progress over Time')}
      loading={loading}
    >
      <Style>
        <div
          ref={ref}
          style={{ position: 'relative', height: 550, maxHeight: 550 }}
        />
      </Style>
    </Widget>
  );
}